import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CargueReprogramacionDesvinculadosComponent } from './CargueReprogramacionDesvinculados.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueReprogramacionDesvinculados',
        component: CargueReprogramacionDesvinculadosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueReprogramacionDesvinculados',
          nombreFormulario : 'Cargue Archivo Reprogramacion Desvinculados'
        } 
    }
];

@NgModule({
    declarations: [
        CargueReprogramacionDesvinculadosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueReprogramacionDesvinculadosComponent
    ],
    bootstrap: [CargueReprogramacionDesvinculadosComponent]
})

export class CargueReprogramacionDesvinculadosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueReprogramacionDesvinculados/CargueReprogramacionDesvinculados.module.ts